import { api } from '@api'
import { userId } from '@state/auth'
import type { VideoForm } from './videoSchema'

export const saveVideo = async (values: VideoForm) => {
	const { data, error } = await api()
		.from('go_watch_videos')
		.insert({ ...values, profile_id: userId() as string })
		.select()
		.single()

	if (error) throw new Error(error.message)
	return data
}

export const updateVideo = async ({
	id,
	values,
}: { id: string; values: VideoForm }) => {
	const { data, error } = await api()
		.from('go_watch_videos')
		.update(values)
		.eq('id', id)
		.select()
		.single()

	if (error) throw new Error(error.message)
	return data
}
